import { useTranslation } from 'react-i18next'
import { Box, MenuItem, TextField } from '@mui/material'
import keys from '@/utils/keys'

import { TransactionTypePayment } from '@/enums/transaction-type-payment.enum'
import { PersonalizationEngineModels } from '@/state/personalization-engine'

type Props = {
  filters: PersonalizationEngineModels.PersonalizationEngineFiltersType
  handleChangeSearch: (field: string, value: any) => void
}

const BalanceFilterType = ({ filters, handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const transactionTypePayment = [
    ...keys(TransactionTypePayment)
      .filter((item) => typeof TransactionTypePayment[item] !== 'string')
      .map((x) => {
        return {
          index: TransactionTypePayment[x],
          value: x,
        }
      }),
  ].sort((a, b) => a.value.localeCompare(b.value))

  const transactionTypePaymentOptions = transactionTypePayment.map((report) => {
    return (
      <MenuItem key={report.index} value={report.index}>
        {t(`reports.transactionTypePayment.${report.value}`)}
      </MenuItem>
    )
  })

  return (
    <TextField
      fullWidth
      name="transactionTypePayment"
      margin="dense"
      variant="outlined"
      type="text"
      id="transactionTypePayment"
      label={t('labels.transactionTypePayment')}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch('transactionTypePayment', e.target.value)
      }}
      value={filters.transactionTypePayment || 'all'}
      select
      sx={{ '& .MuiInputBase-input': { paddingBottom: '15px' } }}
    >
      <MenuItem value="all">
        <Box fontStyle="italic">{t('all')}</Box>
      </MenuItem>
      {transactionTypePaymentOptions}
    </TextField>
  )
}
export default BalanceFilterType
